var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/townobject/".concat(_vm.id)
    }
  }, [_vm.collection ? [_c('v-list-item-avatar', {
    attrs: {
      "size": 48
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.townobjecticon.format(_vm.item.m_ResourceID + '00') + '.jpg'
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.item.m_ObjName))]), _vm.item.m_TitleType != -1 ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.TitleList[_vm.item.m_TitleType].m_DisplayName)))]) : _vm._e()], 1)] : [_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.townobjecticon.format(_vm.item.m_ResourceID + '00') + '.jpg'
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "mr-auto ml-0",
    staticStyle: {
      "max-width": "384px"
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.item.m_ObjName))]), _vm.item.m_TitleType != -1 ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.TitleList[_vm.item.m_TitleType].m_DisplayName)))]) : _vm._e()], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }